import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SessionService } from '../../shared/services/session.service';
declare var createjs: any;

@Component({
  selector: 'app-lyssna-efter-ljudet',
  templateUrl: './lyssna-efter-ljudet.component.html',
  styleUrls: ['./lyssna-efter-ljudet.component.scss']
})


export class LyssnaEfterLjudetComponent implements OnInit {
  private stage: any;
  public bloburl: string;
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<LyssnaEfterLjudetComponent>, @Inject(MAT_DIALOG_DATA) public data: string) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {
    var strbloburl = this.sessionService.bloburl;

    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    var stage = new createjs.Stage("fk_bdcolorcanvas");
    this.stage = stage;
    createjs.Touch.enable(stage);
    createjs.MotionGuidePlugin.install();

    var fk_bdcolorcanvas: any = document.getElementById('fk_bdcolorcanvas');
    fk_bdcolorcanvas.width = 1785;
    fk_bdcolorcanvas.height = 885;

    //Destination for images

    var destination1: any = new createjs.Shape();
    destination1.overColor = "#FFCE37";
    destination1.outColor = "#FFFFFF";
    destination1.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75, 75);
    destination1.setTransform(700, 520);
    destination1.setBounds(625, 450, 155, 155);

    var destination2: any = new createjs.Shape();
    destination2.overColor = "#FFCE37";
    destination2.outColor = "#FFFFFF";
    destination2.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75, 75);
    destination2.setTransform(1075, 520);
    destination2.setBounds(1000, 450, 155, 155);

    var image_rect_dest1 = new createjs.Shape();
    image_rect_dest1.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#000000").drawRect(0, 0, 155, 155);
    image_rect_dest1.setTransform(725, 450);

    var image_rect_dest2 = new createjs.Shape();
    image_rect_dest2.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#000000").drawRect(0, 0, 155, 155);
    image_rect_dest2.setTransform(905, 450);

    var image_rect_dest3 = new createjs.Shape();
    image_rect_dest3.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#000000").drawRect(0, 0, 155, 155);
    image_rect_dest3.setTransform(1200, 350);

    //to select 2 or 3 image option

    var img_rect1 = new createjs.Shape();
    img_rect1.graphics.setStrokeStyle(2).beginFill("#98CD81").beginStroke("#000000").drawCircle(0, 0, 8);
    img_rect1.setTransform(125, 115);
    img_rect1.cursor = 'pointer';
    img_rect1.addEventListener("click", Exercise1);

    var img_rect2 = new createjs.Shape();
    img_rect2.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 8);
    img_rect2.setTransform(125, 155);
    img_rect2.cursor = 'pointer';
    img_rect2.addEventListener("click", Exercise2);

    var img_rect3 = new createjs.Shape();
    img_rect3.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 8);
    img_rect3.setTransform(125, 195);
    img_rect3.cursor = 'pointer';
    img_rect3.addEventListener("click", Exercise3);

    StaticContent();
    Exercise1();

    function StaticContent() {

      var bitmap = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/frame.png");
      bitmap.setTransform(0, 0, 0.992, 0.97);

      var heading = new createjs.Text("Hur många ljud?", "bold 60px Dk-mariken", "#FF0000");

      if (isIOS) {
        var heading = new createjs.Text("Hur många ljud?", "60px Dk-mariken", "#FF0000");
        heading.outline = 2;
        var heading1 = new createjs.Text("Hur många ljud?", "60px Dk-mariken", "#FF0000");
        heading1.textAlign = "center";
        heading1.setTransform(890, 80);
      }
      heading.textAlign = "center";
      heading.setTransform(890, 80);

      var option_container = new createjs.Container();

      var img_rect = new createjs.Shape();
      img_rect.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#98CD81").setStrokeDash([6, 7]).drawRoundRect(0, 0, 150, 130, 15);
      img_rect.setTransform(95, 90);

      var text1 = new createjs.Text("1-2 ljud", "23px MyriadPro-Regular", "#000000");
      text1.setTransform(147, 105);

      var text2 = new createjs.Text("2-3 ljud", "23px MyriadPro-Regular", "#000000");
      text2.setTransform(147, 145.5);

      var text3 = new createjs.Text("3-4 ljud", "23px MyriadPro-Regular", "#000000");
      text3.setTransform(147, 185);

      option_container.addChild(img_rect, text1, text2, text3);

      //2-Rectangles

      var rect_container = new createjs.Container();
      for (var i = 0; i < 2; i++) {
        var rectbox_1 = new createjs.Shape();
        rectbox_1.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#AADDE8").drawRoundRect(0, 0, 155, 155, 10);
        rectbox_1.setTransform(625 + (i * 375), 250);
        rect_container.addChild(rectbox_1);
      }

      stage.addChild(bitmap, heading, heading1, option_container, rect_container);
    }

    function Exercise1() {

      img_rect1.graphics.setStrokeStyle(2).beginFill("#98CD81").beginStroke("#000000").drawCircle(0, 0, 10);
      img_rect2.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10);
      img_rect3.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10);

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage_2" || stage.children[j].name == "removeimage_3" || stage.children[j].name == "bmImg2" || stage.children[j].name == "bmImg3") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }

      var num_text1 = new createjs.Text("1", "100px MyriadPro-Regular", "#696969");
      num_text1.setTransform(680, 284);
      num_text1.name = "removeimage_1";

      var num_text2 = new createjs.Text("2", "100px MyriadPro-Regular", "#696969");
      num_text2.setTransform(1052, 284);
      num_text2.name = "removeimage_1";


      var showimageArr = [strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image1.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image2.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image3.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image4.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image64.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image65.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image66.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image67.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image68.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image69.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image70.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image71.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image72.png"
      ];


      var showimage = [];

      var showimage_x = [1420, 1437, 1450, 1425, 1430, 1435, 1450, 1440, 1430, 1437, 1450, 1435, 1450];
      var showimage_y = [440, 461, 440, 510, 450, 455, 440, 460, 445, 461, 440, 450, 450];
      var showimage_scaleX = [0.37, 0.4, 0.45, 0.29, 0.5, 0.5, 0.45, 0.45, 0.45, 0.5, 0.45, 0.5, 0.5];
      var showimage_scaleY = [0.37, 0.4, 0.45, 0.29, 0.5, 0.5, 0.45, 0.45, 0.45, 0.5, 0.45, 0.5, 0.5];
      var showimage_x1 = [625, 1000, 1010, 1000, 635, 623, 1010, 1020, 1000, 1000, 1010, 1025, 1000];
      var showimage_y1 = [450, 463, 450, 500, 450, 463, 450, 480, 450, 463, 450, 450, 450];

      var destination = [destination1, destination2, destination2, destination2, destination1, destination1,
        destination2, destination2, destination2, destination2, destination2, destination2, destination2];

      var word_text_array = ['ö', 'ko', 'yr', 'ål', 'i', 'å', 'bi', 'fe', 'el', 'kö', 'lo', 'te', 'tå'];
      var word_text_array_x = [685, 1055, 1062, 1060, 692, 685, 1055, 1062, 1060, 1055, 1062, 1060, 1062];
      var word_text_array_y = [640, 640, 630, 640, 640, 642, 640, 640, 640, 640, 640, 640, 640];

      var soundsArr = [strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio1.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio2.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio3.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio4.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio64.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio65.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio66.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio67.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio68.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio69.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio70.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio71.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio72.mp3"];




      var ImageArr = [];
      var tempImageArr = [];

      for (var k = 0; k < showimageArr.length; k++) {
        var ImgArray = { Shape: showimageArr[k], x: showimage_x[k], y: showimage_y[k], x1: showimage_x1[k], y1: showimage_y1[k], scaleX: showimage_scaleX[k], scaleY: showimage_scaleY[k], wordText: word_text_array[k], wordText_x: word_text_array_x[k], wordText_y: word_text_array_y[k], sound: soundsArr[k], destination: destination[k] };
        ImageArr.push(ImgArray);
        tempImageArr.push(ImgArray);
      }


      //JarImage to show random images

      var bagclose = new Image();
      bagclose.crossOrigin = "Anonymous";
      bagclose.src = strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/bag_close.png";

      var bag_close = new createjs.Bitmap(bagclose);
      bag_close.setTransform(1320, 535);
      bag_close.cursor = "pointer";
      bag_close.addEventListener("click", randomimages1);
      bag_close.name = "removeimage_1";
      bag_close.alpha = 0.5;
      //code to load images faster start here 
      var bitmapimage;
      var temp_count = 0;
      function randomimages1(evt) {
        if (bag_close.alpha == 1) {
          temp_count++;
          bag_close.visible = false;
          bag_open.visible = true;
          if (temp_count > 1) {
            gen_image();
          }
          else {
            bitmapimage.visible = true;
          }
        }
      }
      //code to load images faster end here

      var bag_open = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/bag_open.png");
      bag_open.setTransform(1323, 420);
      bag_open.visible = false;
      bag_open.name = "removeimage_1";
      stage.addChild(num_text1, num_text2, bag_close, bag_open);
      gen_image();
      function gen_image() {
        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "bmImg1") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }

        var randomNum = 0;

        function tempmanageaudioplaycount() {
          var audio: any = document.getElementById('my_audio');
          audio.play();

        }

        if (tempImageArr.length == 0) {
          for (var k = 0; k < ImageArr.length; k++) {
            tempImageArr[k] = ImageArr[k];
          }
        }

        randomNum = Math.floor((Math.random() * tempImageArr.length));
        //we have changed the code to load images faster start here 
        var c_shape = new Image();
        c_shape.crossOrigin = "Anonymous";
        c_shape.src = tempImageArr[randomNum].Shape;
        bitmapimage = new createjs.Bitmap(c_shape);
        if (temp_count > 1) {
          bitmapimage.visible = true;
        }
        else {
          bitmapimage.visible = false;
        }
        bitmapimage.image.onload = function () {
          bag_close.alpha = 1;
        }
        //we have changed the code to load images faster end here
        bitmapimage.x = tempImageArr[randomNum].x;
        bitmapimage.y = tempImageArr[randomNum].y;
        bitmapimage.scaleX = tempImageArr[randomNum].scaleX;
        bitmapimage.scaleY = tempImageArr[randomNum].scaleY;
        bitmapimage.name = "bmImg1";
        bitmapimage.cursor = "pointer";

        //audio for safari browser
        var sound_url = tempImageArr[randomNum].sound;
        var audio: any = document.getElementById('my_audio');
        var source: any = document.getElementById('my_audio_src');
        source.src = sound_url;
        audio.load(); //call this to just preload the audio without playing for ie
        // audio.muted = true;

        stage.addChild(bitmapimage);

        bitmapimage.on("mousedown", function (evt: any) {
          this.parent.addChild(this);
          this.offset = {
            x: this.x - evt.stageX,
            y: this.y - evt.stageY
          };
        });

        bitmapimage.on("pressmove", function (evt: any) {

          tempmanageaudioplaycount();

          evt.currentTarget.scaleX = tempImageArr[randomNum].scaleX / 2;
          evt.currentTarget.scaleY = tempImageArr[randomNum].scaleY / 2;

          evt.currentTarget.x = evt.stageX + this.offset.x;
          evt.currentTarget.y = evt.stageY + this.offset.y;

          destination1.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.overColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();
          destination2.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.overColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();


        });

        bitmapimage.on("pressup", function (evt: any) {
          if (intersect(evt.currentTarget, tempImageArr[randomNum].destination)) {
            bitmapimage.x = tempImageArr[randomNum].x1;
            bitmapimage.y = tempImageArr[randomNum].y1;
            bitmapimage.scaleX = tempImageArr[randomNum].scaleX;
            bitmapimage.scaleY = tempImageArr[randomNum].scaleY;
            bitmapimage.mouseEnabled = false;

            destination1.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();
            destination2.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();

            var word_text = new createjs.Text(tempImageArr[randomNum].wordText, "90px MajemaSkol_Exercise_bold", "#696969");
            word_text.setTransform(tempImageArr[randomNum].wordText_x, tempImageArr[randomNum].wordText_y);
            word_text.name = "bmImg1";



            bag_close.visible = true;
            bag_open.visible = false;

            stage.addChild(word_text);





            for (var i = 0; i < tempImageArr.length; i++) {
              var index = tempImageArr[i];
              if (index > -1) {
                tempImageArr.splice(i, 1);
              }
            }
          }
          else {
            bitmapimage.scaleX = tempImageArr[randomNum].scaleX;
            bitmapimage.scaleY = tempImageArr[randomNum].scaleY;
            createjs.Tween.get(bitmapimage)
              .to({ x: tempImageArr[randomNum].x, y: tempImageArr[randomNum].y }, 500);

          }
        });
      }

    }

    function Exercise2() {

      img_rect1.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10);
      img_rect2.graphics.setStrokeStyle(2).beginFill("#98CD81").beginStroke("#000000").drawCircle(0, 0, 10);
      img_rect3.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10);

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage_1" || stage.children[j].name == "removeimage_3" || stage.children[j].name == "bmImg1" || stage.children[j].name == "bmImg3") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }

      var num_text1 = new createjs.Text("2", "100px MyriadPro-Regular", "#696969");
      num_text1.setTransform(680, 284);
      num_text1.name = "removeimage_2";

      var num_text2 = new createjs.Text("3", "100px MyriadPro-Regular", "#696969");
      num_text2.setTransform(1054, 284);
      num_text2.name = "removeimage_2";


      var showimageArr = [strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image2.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image3.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image4.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image5.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image6.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image7.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image8.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image9.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image10.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image11.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image12.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image13.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image14.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image15.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image16.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image17.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image18.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image19.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image20.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image21.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image22.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image23.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image24.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image25.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image26.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image27.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image28.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image29.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image30.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image31.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image32.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image33.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image34.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image35.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image36.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image38.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image39.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image40.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image41.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image42.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image43.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image44.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image45.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image46.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image66.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image67.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image68.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image69.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image70.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image71.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image72.png"
      ];


      var showimage = [];


      var showimage_x = [1430, 1432, 1433, 1436, 1428,
        1420, 1437, 1427, 1437, 1480,
        1427, 1452, 1444, 1424, 1429,
        1423, 1454, 1442, 1429, 1455,
        1432, 1402, 1432, 1432, 1432,
        1442, 1430, 1431, 1460, 1430,
        1435, 1435, 1420, 1460, 1428,
        1430, 1420, 1430, 1430, 1440,
        1425, 1439, 1480, 1435, 1450,
        1440, 1430, 1437, 1450, 1435,
        1450];

      var showimage_y = [455, 446, 529, 460, 480,
        515, 470, 465, 455, 500,
        478, 432, 495, 509, 482,
        451, 457, 430, 443, 465,
        465, 455, 475, 473, 502,
        470, 460, 435, 470, 479,
        422, 480, 510, 465, 478,
        458, 508, 488, 428, 455,
        455, 475, 475, 440, 440,
        460, 445, 461, 440, 450,
        450];

      var showimage_scaleX = [0.42, 0.42, 0.29, 0.29, 0.28, 0.33, 0.45, 0.45, 0.45, 0.45, 0.45, 0.33, 0.33,
        0.40, 0.35, 0.37, 0.52, 0.45, 0.42, 0.70, 0.65, 0.55, 0.48, 0.48, 0.48, 0.31,
        0.50, 0.35, 0.67, 0.35, 0.55, 0.40, 0.52, 0.68, 0.38, 0.38, 0.37, 0.50,
        0.47, 0.38, 0.37, 0.65, 0.60, 0.50, 0.45, 0.45, 0.45, 0.5, 0.45, 0.5, 0.5];

      var showimage_scaleY = [0.42, 0.42, 0.29, 0.29, 0.28, 0.33, 0.45, 0.45, 0.45, 0.45, 0.45, 0.33, 0.33,
        0.40, 0.35, 0.37, 0.52, 0.45, 0.42, 0.70, 0.65, 0.55, 0.48, 0.48, 0.48, 0.31,
        0.50, 0.35, 0.67, 0.35, 0.55, 0.40, 0.52, 0.68, 0.38, 0.38, 0.37, 0.50,
        0.47, 0.38, 0.37, 0.65, 0.60, 0.50, 0.45, 0.45, 0.45, 0.5, 0.45, 0.5, 0.5];

      var showimage_x1 = [625, 642, 626, 1021, 1000,
        1000, 996, 1002, 1022, 1055,
        1005, 1050, 1027, 1003, 1003,
        1007, 1023, 1021, 1005, 1040,
        998, 1003, 1003, 1005, 1003,
        1001, 1001, 1031, 1040, 1000,
        998, 1000, 1000, 1042, 998, 1000, 1000, 1000, 1020, 1000, 1000, 999, 1045,
        1015, 630, 640, 620, 620, 630, 645, 620];

      var showimage_y1 = [450, 457, 497, 467, 467, 495, 485, 465, 465, 478, 478, 454, 480, 492, 472,
        461, 453, 448, 453, 450, 465, 465, 470, 473, 490, 480, 465, 453, 452, 479,
        450, 480, 490, 452, 482, 458, 498, 480, 450, 465, 465, 475, 450,
        450, 450, 480, 450, 463, 450, 450, 450];

      var destination = [destination1, destination1, destination1, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination1, destination1, destination1, destination1, destination1, destination1, destination1];

      var word_text_array = ['ko', 'yr', 'ål', 'apa', 'arm',
        'bil', 'bok', 'båt', 'eld', 'fem',
        'fot', 'fyr', 'gul', 'haj', 'hus',
        'kam', 'lås', 'lök', 'mus', 'nio',
        'nos', 'nål', 'orm', 'ost', 'pil',
        'räv', 'röd', 'sax', 'sex', 'sko',
        'sol', 'såg', 'tak', 'tre', 'tåg',
        'val', 'våg', 'wok', 'yxa', 'åra',
        'älg', 'öga', 'öra', 'örn', 'bi',
        'fe', 'el', 'kö', 'lo', 'te', 'tå'];

      var word_text_array_x = [685, 680, 680, 1040, 1040, 1049, 1038, 1041, 1043, 1040,
        1050, 1050, 1045, 1045, 1040, 1035, 1050, 1048, 1031, 1050,
        1043, 1046, 1037, 1043, 1047, 1045, 1045, 1045, 1045, 1045,
        1045, 1045, 1045, 1045, 1045, 1045, 1035, 1035, 1045, 1045, 1045, 1040, 1040, 1040, 675, 682, 680, 675, 682, 680, 682];

      var word_text_array_y = [640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640, 640];

      var soundsArr = [strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio2.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio3.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio4.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio5.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio6.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio7.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio8.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio9.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio10.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio11.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio12.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio13.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio14.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio15.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio16.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio17.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio18.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio19.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio20.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio21.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio22.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio23.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio24.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio25.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio26.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio27.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio28.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio29.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio30.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio31.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio32.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio33.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio34.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio35.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio36.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio38.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio39.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio40.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio41.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio42.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio43.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio44.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio45.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio46.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio66.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio67.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio68.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio69.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio70.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio71.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio72.mp3"];



      var ImageArr = [];
      var tempImageArr = [];

      for (var k = 0; k < showimageArr.length; k++) {
        var ImgArray = { Shape: showimageArr[k], x: showimage_x[k], y: showimage_y[k], x1: showimage_x1[k], y1: showimage_y1[k], scaleX: showimage_scaleX[k], scaleY: showimage_scaleY[k], wordText: word_text_array[k], wordText_x: word_text_array_x[k], wordText_y: word_text_array_y[k], sound: soundsArr[k], destination: destination[k] };
        ImageArr.push(ImgArray);
        tempImageArr.push(ImgArray);
      }


      //JarImage to show random images

      var bagclose = new Image();
      bagclose.crossOrigin = "Anonymous";
      bagclose.src = strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/bag_close.png";

      var bag_close = new createjs.Bitmap(bagclose);
      bag_close.setTransform(1320, 535);
      bag_close.cursor = "pointer";
      bag_close.addEventListener("click", randomimages2);
      bag_close.name = "removeimage_2";
      bag_close.alpha = 0.5;
      //code to load images faster start here 
      var bitmapimage1;
      var temp_count = 0;
      function randomimages2(evt) {
        if (bag_close.alpha == 1) {
          temp_count++;
          bag_close.visible = false;
          bag_open.visible = true;
          if (temp_count > 1) {
            gen_image();
          }
          else {
            bitmapimage1.visible = true;
          }
        }
      }

      var bag_open = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/bag_open.png");
      bag_open.setTransform(1323, 420);
      bag_open.visible = false;
      bag_open.name = "removeimage_2";
      stage.addChild(num_text1, num_text2, bag_close, bag_open);
      gen_image();
      function gen_image() {
        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "bmImg2") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }


        var randomNum1 = 0;

        function tempmanageaudioplaycount() {
          var audio: any = document.getElementById('my_audio');
          audio.play();

        }

        if (tempImageArr.length == 0) {
          for (var k = 0; k < ImageArr.length; k++) {
            tempImageArr[k] = ImageArr[k];
          }
        }

        randomNum1 = Math.floor((Math.random() * tempImageArr.length));
        //we have changed the code to load images faster start here 
        var c_shape = new Image();
        c_shape.crossOrigin = "Anonymous";
        c_shape.src = tempImageArr[randomNum1].Shape;
        bitmapimage1 = new createjs.Bitmap(c_shape);
        if (temp_count > 1) {
          bitmapimage1.visible = true;
        }
        else {
          bitmapimage1.visible = false;
        }
        bitmapimage1.image.onload = function () {
          bag_close.alpha = 1;
        }
        //we have changed the code to load images faster end here 
        bitmapimage1.x = tempImageArr[randomNum1].x;
        bitmapimage1.y = tempImageArr[randomNum1].y;
        bitmapimage1.scaleX = tempImageArr[randomNum1].scaleX;
        bitmapimage1.scaleY = tempImageArr[randomNum1].scaleY;
        bitmapimage1.name = "bmImg2";
        bitmapimage1.cursor = "pointer";
        //audio for safari browser
        var sound_url = tempImageArr[randomNum1].sound;
        var audio: any = document.getElementById('my_audio');
        var source: any = document.getElementById('my_audio_src');
        source.src = sound_url;
        audio.load(); //call this to just preload the audio without playing for ie
        // audio.muted = true;

        stage.addChild(bitmapimage1);

        bitmapimage1.on("mousedown", function (evt: any) {
          this.parent.addChild(this);
          this.offset = {
            x: this.x - evt.stageX,
            y: this.y - evt.stageY
          };
        });

        bitmapimage1.on("pressmove", function (evt: any) {

          tempmanageaudioplaycount();

          evt.currentTarget.scaleX = tempImageArr[randomNum1].scaleX / 2;
          evt.currentTarget.scaleY = tempImageArr[randomNum1].scaleY / 2;

          evt.currentTarget.x = evt.stageX + this.offset.x;
          evt.currentTarget.y = evt.stageY + this.offset.y;

          destination1.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.overColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();
          destination2.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.overColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();

        });

        bitmapimage1.on("pressup", function (evt: any) {
          if (intersect(evt.currentTarget, tempImageArr[randomNum1].destination)) {
            bitmapimage1.x = tempImageArr[randomNum1].x1;
            bitmapimage1.y = tempImageArr[randomNum1].y1;

            bitmapimage1.scaleX = tempImageArr[randomNum1].scaleX;
            bitmapimage1.scaleY = tempImageArr[randomNum1].scaleY;

            bitmapimage1.mouseEnabled = false;

            destination1.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();
            destination2.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();

            var word_text_1 = new createjs.Text(tempImageArr[randomNum1].wordText, "90px MajemaSkol_Exercise_bold", "#696969");
            word_text_1.setTransform(tempImageArr[randomNum1].wordText_x, tempImageArr[randomNum1].wordText_y);
            word_text_1.name = "bmImg2";



            bag_close.visible = true;
            bag_open.visible = false;

            stage.addChild(word_text_1);


            for (var i = 0; i < tempImageArr.length; i++) {
              var index = tempImageArr[i];
              if (index > -1) {
                tempImageArr.splice(i, 1);
              }
            }
          }
          else {
            bitmapimage1.scaleX = tempImageArr[randomNum1].scaleX;
            bitmapimage1.scaleY = tempImageArr[randomNum1].scaleY;
            createjs.Tween.get(bitmapimage1)
              .to({ x: tempImageArr[randomNum1].x, y: tempImageArr[randomNum1].y }, 500);

          }
        });
      }
    }


    function Exercise3() {

      img_rect1.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10);
      img_rect2.graphics.setStrokeStyle(2).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10);
      img_rect3.graphics.setStrokeStyle(2).beginFill("#98CD81").beginStroke("#000000").drawCircle(0, 0, 10);

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage_1" || stage.children[j].name == "removeimage_2" || stage.children[j].name == "bmImg1" || stage.children[j].name == "bmImg2") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }

      var num_text1 = new createjs.Text("3", "100px MyriadPro-Regular", "#696969");
      num_text1.setTransform(680, 284);
      num_text1.name = "removeimage_3";

      var num_text2 = new createjs.Text("4", "100px MyriadPro-Regular", "#696969");
      num_text2.setTransform(1052, 284);
      num_text2.name = "removeimage_3";


      var showimageArr = [strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image5.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image6.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image7.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image8.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image9.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image10.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image11.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image12.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image13.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image14.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image15.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image16.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image17.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image18.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image19.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image20.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image21.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image22.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image23.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image24.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image25.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image26.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image27.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image28.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image29.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image30.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image31.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image32.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image33.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image34.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image35.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image36.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image38.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image39.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image40.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image41.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image42.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image43.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image44.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image45.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image46.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image47.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image48.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image49.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image50.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image51.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image52.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image53.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image54.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image55.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image56.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image57.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image58.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image59.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image60.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image61.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image62.png",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/image63.png"
      ];


      var showimage = [];


      var showimage_x = [1436, 1428, 1420, 1437, 1427, 1437, 1463, 1427, 1452, 1444, 1424, 1429, 1423, 1454,
        1436, 1429, 1434, 1432, 1402, 1432, 1432, 1432, 1442, 1430, 1431, 1435, 1430, 1435, 1435, 1420,
        1428, 1447, 1430, 1420, 1430, 1430, 1440, 1425, 1439, 1465, 1435, 1430, 1440, 1437, 1430, 1441, 1425,
        1433, 1445, 1442, 1461, 1429, 1444, 1422, 1434, 1445, 1430, 1432];

      var showimage_y = [460, 480, 515, 470, 465, 455, 486, 478, 432, 495, 509, 482, 451, 457, 430, 443,
        430, 465, 455, 475, 473, 502, 470, 460, 435, 436, 479, 422,
        480, 510, 435, 458, 453, 508, 488, 428, 455, 455, 475, 427, 440,
        435, 475, 485, 510, 450, 515, 480, 435, 458, 426, 495, 433, 505, 480, 438, 435, 477];

      var showimage_scaleX = [0.29, 0.28, 0.33, 0.45, 0.45, 0.45, 0.45, 0.45, 0.33, 0.33,
        0.40, 0.35, 0.37, 0.52, 0.45, 0.42, 0.70, 0.65, 0.55, 0.48, 0.48, 0.48, 0.31,
        0.50, 0.35, 0.67, 0.35, 0.55, 0.40, 0.52, 0.68, 0.38, 0.38, 0.37, 0.50,
        0.47, 0.38, 0.37, 0.65, 0.60, 0.50, 0.5, 0.5, 0.65, 0.40, 0.50, 0.43, 0.44, 0.55,
        0.92, 0.40, 0.36, 0.35, 0.26, 0.40, 0.40, 0.40, 0.35];

      var showimage_scaleY = [0.29, 0.28, 0.33, 0.45, 0.45, 0.45, 0.45, 0.45, 0.33, 0.33,
        0.40, 0.35, 0.37, 0.52, 0.45, 0.42, 0.70, 0.65, 0.55, 0.48, 0.48, 0.48, 0.31,
        0.50, 0.35, 0.67, 0.35, 0.55, 0.40, 0.52, 0.68, 0.38, 0.38, 0.37, 0.50,
        0.47, 0.38, 0.37, 0.65, 0.60, 0.50, 0.5, 0.5, 0.65, 0.40, 0.50, 0.43, 0.44, 0.55,
        0.92, 0.40, 0.36, 0.35, 0.26, 0.40, 0.40, 0.40, 0.35];

      var showimage_x1 = [642, 625, 625, 620, 626, 646, 667, 629, 674, 651,
        627, 627, 631, 647, 645, 629, 649, 622, 627, 627,
        629, 627, 625, 625, 655, 655, 624, 622, 624, 624,
        654, 622, 624, 624, 624, 644, 624, 624, 623,
        659, 639, 1015, 1005, 1000, 1000, 1005, 999, 1002, 1022,
        1002, 1026, 996, 1005, 1002, 1002, 1002, 997, 997];

      var showimage_y1 = [467, 467, 490, 485, 465, 465, 478, 478, 454, 480,
        492, 472, 461, 453, 448, 453, 450, 465, 465, 470,
        473, 490, 480, 465, 453, 452, 479, 450, 480, 490,
        452, 482, 458, 498, 480, 450, 465, 465, 475,
        450, 450, 452, 472, 472, 482, 462, 482, 482, 454,
        465, 448, 483, 453, 483, 463, 460, 455, 475];

      var destination = [destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1,
        destination1, destination1, destination1, destination1, destination1,
        destination1, destination1, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2, destination2,
        destination2, destination2, destination2, destination2];

      var word_text_array = ['apa', 'arm',
        'bil', 'bok', 'båt', 'eld', 'fem',
        'fot', 'fyr', 'gul', 'haj', 'hus',
        'kam', 'lås', 'lök', 'mus', 'nio',
        'nos', 'nål', 'orm', 'ost', 'pil',
        'räv', 'röd', 'sax', 'sex', 'sko',
        'sol', 'såg', 'tak', 'tre', 'tåg',
        'val', 'våg', 'wok', 'yxa',
        'åra', 'älg', 'öga', 'öra', 'örn',
        'jojo', 'kiwi', 'korv', 'lego', 'lila',
        'majs', 'myra', 'måne', 'oliv', 'stol', 'taxi',
        'träd', 'tält', 'ubåt', 'åska', 'åsna', 'ödla'];

      var word_text_array_x = [665, 665, 665, 662, 665, 667, 664, 674, 674, 669,
        669, 664, 659, 674, 672, 655, 667, 667, 670, 661,
        667, 675, 669, 669, 669, 669, 669, 669, 669, 669,
        669, 669, 669, 659, 659, 669, 669, 669, 664,
        664, 664, 1040, 1035, 1050, 1040, 1027, 1023, 1032, 1035,
        1041, 1038, 1041, 1030, 1030, 1030, 1030, 1030, 1030];

      var word_text_array_y = [640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640, 640,
        640, 640, 640, 640, 640, 640, 640, 640, 640];

      var soundsArr = [strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio5.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio6.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio7.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio8.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio9.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio10.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio11.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio12.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio13.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio14.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio15.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio16.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio17.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio18.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio19.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio20.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio21.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio22.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio23.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio24.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio25.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio26.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio27.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio28.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio29.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio30.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio31.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio32.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio33.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio34.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio35.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio36.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio38.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio39.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio40.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio41.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio42.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio43.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio44.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio45.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio46.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio47.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio48.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio49.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio50.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio51.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio52.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio53.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio54.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio55.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio56.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio57.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio58.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio59.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio60.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio61.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio62.mp3",
      strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Sounds/audio63.mp3"];




      var ImageArr = [];
      var tempImageArr = [];

      for (var k = 0; k < showimageArr.length; k++) {
        var ImgArray = { Shape: showimageArr[k], x: showimage_x[k], y: showimage_y[k], x1: showimage_x1[k], y1: showimage_y1[k], scaleX: showimage_scaleX[k], scaleY: showimage_scaleY[k], wordText: word_text_array[k], wordText_x: word_text_array_x[k], wordText_y: word_text_array_y[k], sound: soundsArr[k], destination: destination[k] };
        ImageArr.push(ImgArray);
        tempImageArr.push(ImgArray);
      }


      //JarImage to show random images

      var bagclose = new Image();
      bagclose.crossOrigin = "Anonymous";
      bagclose.src = strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/bag_close.png";

      var bag_close = new createjs.Bitmap(bagclose);
      bag_close.setTransform(1320, 535);
      bag_close.cursor = "pointer";
      bag_close.addEventListener("click", randomimages3);
      bag_close.name = "removeimage_3";
      bag_close.alpha = 0.5;
      //code to load images faster start here 
      var bitmapimage2;
      var temp_count = 0;
      function randomimages3(evt) {
        if (bag_close.alpha == 1) {
          temp_count++;
          bag_close.visible = false;
          bag_open.visible = true;
          if (temp_count > 1) {
            gen_image();
          }
          else {
            bitmapimage2.visible = true;
          }
        }
      }

      var bag_open = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-Tincan/Lyssnaefterljudet/Images/bag_open.png");
      bag_open.setTransform(1323, 420);
      bag_open.visible = false;
      bag_open.name = "removeimage_3";
      stage.addChild(num_text1, num_text2, bag_close, bag_open);

      gen_image();
      function gen_image() {
        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "bmImg3") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }


        var randomNum1 = 0;

        function tempmanageaudioplaycount() {
          var audio: any = document.getElementById('my_audio');
          audio.play();

        }

        if (tempImageArr.length == 0) {
          for (var k = 0; k < ImageArr.length; k++) {
            tempImageArr[k] = ImageArr[k];
          }
        }


        randomNum1 = Math.floor((Math.random() * tempImageArr.length));
        //we have changed the code to load images faster start here 
        var c_shape = new Image();
        c_shape.crossOrigin = "Anonymous";
        c_shape.src = tempImageArr[randomNum1].Shape;
        bitmapimage2 = new createjs.Bitmap(c_shape);
        if (temp_count > 1) {
          bitmapimage2.visible = true;
        }
        else {
          bitmapimage2.visible = false;
        }
        bitmapimage2.image.onload = function () {
          bag_close.alpha = 1;
        }
        bitmapimage2.x = tempImageArr[randomNum1].x;
        bitmapimage2.y = tempImageArr[randomNum1].y;
        bitmapimage2.scaleX = tempImageArr[randomNum1].scaleX;
        bitmapimage2.scaleY = tempImageArr[randomNum1].scaleY;
        bitmapimage2.name = "bmImg3";
        bitmapimage2.cursor = "pointer";

        //audio for safari browser
        var sound_url = tempImageArr[randomNum1].sound;
        var audio: any = document.getElementById('my_audio');
        var source: any = document.getElementById('my_audio_src');
        source.src = sound_url;
        audio.load(); //call this to just preload the audio without playing for ie
        // audio.muted = true;
        stage.addChild(bitmapimage2);

        bitmapimage2.on("mousedown", function (evt: any) {
          this.parent.addChild(this);
          this.offset = {
            x: this.x - evt.stageX,
            y: this.y - evt.stageY
          };
        });

        bitmapimage2.on("pressmove", function (evt: any) {

          tempmanageaudioplaycount();

          evt.currentTarget.scaleX = tempImageArr[randomNum1].scaleX / 2;
          evt.currentTarget.scaleY = tempImageArr[randomNum1].scaleY / 2;

          evt.currentTarget.x = evt.stageX + this.offset.x;
          evt.currentTarget.y = evt.stageY + this.offset.y;

          destination1.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.overColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();
          destination2.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.overColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();


        });

        bitmapimage2.on("pressup", function (evt: any) {
          if (intersect(evt.currentTarget, tempImageArr[randomNum1].destination)) {
            bitmapimage2.x = tempImageArr[randomNum1].x1;
            bitmapimage2.y = tempImageArr[randomNum1].y1;

            bitmapimage2.scaleX = tempImageArr[randomNum1].scaleX;
            bitmapimage2.scaleY = tempImageArr[randomNum1].scaleY;

            bitmapimage2.mouseEnabled = false;

            destination1.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination1.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();
            destination2.graphics.clear().setStrokeStyle(2).f('#FFFFFF').beginStroke(destination2.outColor).setStrokeDash([6, 6]).drawCircle(0, 0, 75).endFill();

            var word_text_1 = new createjs.Text(tempImageArr[randomNum1].wordText, "90px MajemaSkol_Exercise_bold", "#696969");
            word_text_1.setTransform(tempImageArr[randomNum1].wordText_x, tempImageArr[randomNum1].wordText_y);
            word_text_1.name = "bmImg3";



            bag_close.visible = true;
            bag_open.visible = false;

            stage.addChild(word_text_1);


            for (var i = 0; i < tempImageArr.length; i++) {
              var index = tempImageArr[i];
              if (index > -1) {
                tempImageArr.splice(i, 1);
              }
            }
          }
          else {
            bitmapimage2.scaleX = tempImageArr[randomNum1].scaleX;
            bitmapimage2.scaleY = tempImageArr[randomNum1].scaleY;
            createjs.Tween.get(bitmapimage2)
              .to({ x: tempImageArr[randomNum1].x, y: tempImageArr[randomNum1].y }, 500);

          }
        });
      }
    }


    function intersect(obj1, obj2) {
      var objBounds1 = obj1.getBounds().clone();
      var objBounds2 = obj2.getBounds().clone();

      var pt = obj1.globalToLocal(objBounds2.x, objBounds2.y);

      var h1 = -(objBounds1.height / 2 + objBounds2.height);
      var h2 = objBounds2.width / 2;
      var w1 = -(objBounds1.width / 2 + objBounds2.width);
      var w2 = objBounds2.width / 2;


      if (pt.x > w2 || pt.x < w1) return false;
      if (pt.y > h2 || pt.y < h1) return false;

      return true;
    }
    stage.addChild(destination1, destination2, img_rect1, img_rect2, img_rect3);
    stage.mouseMoveOutside = false;
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }


  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
    let toggler: any = document.getElementById("toggler");
    if (toggler) {
      toggler.style.visibility = "visible";
    }
  }
}

